export const tenderOfferDictionaries = new Map<string, string>()
    .set("scale", "scale")
    .set("recommended", "recommended");
